import { render, staticRenderFns } from "./appeal.vue?vue&type=template&id=37ec7aa5"
import script from "./appeal.vue?vue&type=script&lang=js"
export * from "./appeal.vue?vue&type=script&lang=js"
import style0 from "./appeal.vue?vue&type=style&index=0&id=37ec7aa5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports